import React from 'react';
import Icon from '@mui/material/Icon';
import Chip from '@mui/material/Chip';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

import { moneyTry, roleLabel, workTypeLabel } from '../../../utils/staffFormatters';

import { StatCard } from 'shared/ui/soft/StatCard';
import { RowItem } from 'shared/ui/soft/RowItem';
import { PillIcon } from 'shared/ui/soft/PillIcon';
import { SoftCard } from 'shared/ui/soft/SoftCard';
export function OverviewPanel({
  active,
  staff,
  weeklySchedule,
  metrics,
  revenueTone,
  costTone,
  onGoLogs,
}) {
  if (!active) return <div style={{ display: 'none' }} />;

  return (
    <MDBox sx={{ display: 'grid', gap: 1.25 }}>
      <MDBox
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
          gap: 1.25,
        }}
      >
        <StatCard
          tone="teal"
          icon="event"
          label="Haftalık Program"
          value={`${
            weeklySchedule.filter((d) => (d.slots || []).join('').includes(':')).length
          } gün aktif`}
          hint="Seans yoğunluğu"
        />
        <StatCard
          tone="violet"
          icon="groups"
          label="Üye Sayısı"
          value={`${metrics.memberCount}`}
          hint="Aktif bağlı üye"
        />
        <StatCard
          tone="amber"
          icon="payments"
          label="Kazanç (haftalık)"
          value={moneyTry(metrics.weeklyRevenue)}
          hint="İstenen: büyük kırmızı"
          valueTone={revenueTone}
        />
        <StatCard
          tone="blue"
          icon="receipt_long"
          label="Maliyet/Pay (haftalık)"
          value={moneyTry(metrics.weeklyCost)}
          hint="İstenen: küçük yeşil"
          valueTone={costTone}
        />
      </MDBox>

      <SoftCard>
        <MDBox
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1.2fr .8fr' },
            gap: 1.25,
          }}
        >
          <MDBox sx={{ display: 'grid', gap: 1 }}>
            <RowItem
              icon="badge"
              tone="teal"
              title="Kimlik"
              subtitle="Rol / çalışma tipi"
              right={
                <Chip
                  size="small"
                  label={`${roleLabel(staff.role)} • ${workTypeLabel(staff.workType)}`}
                  variant="outlined"
                  sx={{
                    borderRadius: '999px',
                    fontWeight: 800,
                    borderColor: 'rgba(0,150,136,.22)',
                    background: 'rgba(0,150,136,.04)',
                  }}
                />
              }
            />

            <RowItem
              icon="call"
              tone="amber"
              title="Telefon"
              subtitle={staff.phone || '-'}
              right={<Icon sx={{ opacity: 0.35 }}>chevron_right</Icon>}
            />

            <RowItem
              icon="mail"
              tone="violet"
              title="E-posta"
              subtitle={staff.email || '-'}
              right={<Icon sx={{ opacity: 0.35 }}>chevron_right</Icon>}
            />
          </MDBox>

          <MDBox sx={{ display: 'grid', gap: 1 }}>
            <SoftCard sx={{ p: 1.6 }}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <PillIcon icon="insights" tone="blue" />
                <MDBox>
                  <MDTypography variant="button" fontWeight="bold">
                    Bugün / Son 7 Gün
                  </MDTypography>
                  <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
                    (mock) ödeme, seans, üye
                  </MDTypography>
                </MDBox>
              </MDBox>

              <MDBox sx={{ mt: 1.25, display: 'grid', gap: 0.75 }}>
                <MDTypography variant="button" sx={{ opacity: 0.9 }}>
                  • Ödeme: <b>3 işlem</b>
                </MDTypography>
                <MDTypography variant="button" sx={{ opacity: 0.9 }}>
                  • Seans: <b>11</b>
                </MDTypography>
                <MDTypography variant="button" sx={{ opacity: 0.9 }}>
                  • Üye ekleme: <b>2</b>
                </MDTypography>
              </MDBox>
            </SoftCard>

            <MDButton
              variant="gradient"
              color="info"
              sx={{ borderRadius: '14px' }}
              onClick={onGoLogs}
            >
              <Icon sx={{ mr: 0.5, fontSize: 18 }}>manage_search</Icon>
              Logları İncele
            </MDButton>
          </MDBox>
        </MDBox>
      </SoftCard>
    </MDBox>
  );
}
